import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;

// Public stock status per product slug, sourced from our own warehouse inventory (not Shopify).
export function useStock() {
  const [stock, setStock] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/stock").then(({ data }) => { cache = data || {}; return cache; }).catch(() => ({}));
    let on = true;
    inflight.then((s) => { if (on) setStock(s); });
    return () => { on = false; };
  }, []);
  return stock;
}
